export default __webpack_public_path__ + "static/media/sign-in-welcome-4.a015ea73.jpg";